import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Simcard } from '../../shared/interfaces/equipment.interfaces';

const basePath = '/simcard';

@Injectable({
  providedIn: 'root'
})

export class SimcardService {

  constructor(private http: HttpClient) { }

  updateSimcard(payload: Simcard): Observable<any>{
    const body = { simcard: payload };
    return this.http.post<any>(basePath, body);
  }
}